import React from 'react'

import CheckedIcon from 'Assets/Images/icons/checked'

export const CheckboxStandaloneUnstyled = ({ className, input, ...others }) => (
  <div className={className}>
    <div className="checkbox-wrapper">
      <input type="checkbox" {...input} {...others} checked={input.value} />
      <CheckedIcon />
    </div>
    <label htmlFor={others.id}>{others.label || ''}</label>
  </div>
)
